import { ListElement } from "../../../../../components";
import { twMerge } from "tailwind-merge";
import { useRef, useState } from "react";
import { SellarImportsPayoutType } from "../types/common";
import { useSellarImportPayoutList } from "../hooks/useSellarImportPayoutList";
import { StatusBadge } from "./StatusBadge";
import { AdminOnly } from "../../../../../components/authFilter/AdminOnly";
import { Button, H5, Icon } from "@sellar-io/components";
import { CreateSellarPayoutDialog } from "./CreateSellarPayoutDialog";
import { formatDate } from "../../../../../utils/formatDate";

export const SellarImportsPayoutsCardList = ({
  onSelectPayout,
}: {
  onSelectPayout: (id: number) => void;
}) => {
  const [createPayoutDialogActive, setCreatePayoutDialogActive] =
    useState(false);

  const sellarImportPayoutsQuery = useSellarImportPayoutList({});
  const sellarImportsPayoutsList = sellarImportPayoutsQuery.data?.rows ?? [];

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  return (
    <>
      <div
        className={twMerge(
          "[scrollbar-width:none] overflow-auto border-zinc-300 [::-webkit-scrollbar]:hidden",
        )}
        ref={scrollContainerRef}
      >
        <AdminOnly>
          <div className="my-4 flex justify-end">
            <Button onClick={() => setCreatePayoutDialogActive(true)}>
              <Icon icon="PLUS" />
              Create payout
            </Button>
          </div>
        </AdminOnly>

        {sellarImportsPayoutsList.map((SellarCreditItem) => (
          <SellarImportsPayoutCard
            payoutItem={SellarCreditItem}
            key={SellarCreditItem.id}
            onSelectPayout={onSelectPayout}
          />
        ))}
      </div>

      <CreateSellarPayoutDialog
        active={createPayoutDialogActive}
        onDismiss={() => setCreatePayoutDialogActive(false)}
      />
    </>
  );
};

const SellarImportsPayoutCard = ({
  payoutItem,
  onSelectPayout,
}: {
  payoutItem: SellarImportsPayoutType;
  onSelectPayout: (id: number) => void;
}) => {
  const { captureStart, captureEnd } = payoutItem;
  return (
    <ListElement
      onClick={() => {
        onSelectPayout(payoutItem.id);
      }}
    >
      <div className={"flex flex-col gap-1"}>
        <span className="text-xs">PAY #{payoutItem.id}</span>
        <H5>
          <span>
            {formatDate(captureStart, {
              format: "Do MMM YYYY",
            })}{" "}
            -{" "}
            {formatDate(captureEnd, {
              format: "Do MMM YYYY",
            })}
          </span>
        </H5>
        <div className="mt-2">
          <StatusBadge status={payoutItem.status} />
        </div>
      </div>
    </ListElement>
  );
};
